import { useQuery } from '@tanstack/react-query';
import type { DemandPreview, PlanningsData, StoragesData } from './types';

export const QUERY_KEYS = {
  demandPreview: ['trajectory-optimization', 'demand-preview'] as const,
  plannings:     ['trajectory-optimization', 'plannings'] as const,
  storages:      ['trajectory-optimization', 'storages'] as const,
};

export function useDemandPreview() {
  return useQuery({
    queryKey: QUERY_KEYS.demandPreview,
    queryFn: async () => {
      const response = await fetch('/api/trajectory-optimization/demand-preview');
      if (!response.ok) throw new Error('Impossible de charger la prévisualisation des données.');
      return response.json() as Promise<DemandPreview>;
    },
  });
}

export function usePlannings() {
  return useQuery({
    queryKey: QUERY_KEYS.plannings,
    queryFn: async () => {
      const response = await fetch('/api/trajectory-optimization/plannings');
      if (!response.ok) throw new Error('Impossible de charger les plannings.');
      return response.json() as Promise<PlanningsData>;
    },
  });
}

export function useStorages() {
  return useQuery({
    queryKey: QUERY_KEYS.storages,
    queryFn: async () => {
      const response = await fetch('/api/trajectory-optimization/storages');
      if (!response.ok) throw new Error('Impossible de charger les stockages.');
      return response.json() as Promise<StoragesData>;
    },
  });
}
